module.exports = __webpack_public_path__ + "img/bg_m.ec9dd553.jpg";